import { SortDirection } from "src/types";
import { TaskSortingDirection } from "src/redux/taskFilters/types";

const mapSortingEnums = {
  [TaskSortingDirection.Ascending]: SortDirection.Ascending,
  [TaskSortingDirection.Descending]: SortDirection.Descending,
};

export default function getMappedSortingDirection(
  sortingDirection: TaskSortingDirection | undefined,
): SortDirection {
  return sortingDirection
    ? mapSortingEnums[sortingDirection]
    : SortDirection.Descending;
}
